import { render, staticRenderFns } from "./login.vue?vue&type=template&id=c0cfacaa&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormFieldInput: require('/builder/apps/msp/components/Form/FieldInput.vue').default,BaseLink: require('/builder/apps/msp/components/Base/Link.vue').default})
